import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import AdminDashboard from './components/AdminDashboard';
import StoreDashboard from './components/StoreDashboard';

class Dashboard extends Component {
  constructor() {
    super();
    this.state = {};
    this.userData = JSON.parse(localStorage.getItem('userData'));
  }

  render() {
    if (this.userData == null) {
      return (<Redirect to="/login" />);
    }
    const usertype = parseInt(this.userData.type, 10);

    return (
      <Container>
        { usertype === 1 || usertype === 5 || usertype === 6 ? <AdminDashboard />
          : usertype === 4 ? <StoreDashboard />
          : ''
        }
      </Container>
    );
  }
}

export default Dashboard;
